import { render, staticRenderFns } from "./StatisticsBlock.vue?vue&type=template&id=4c37d23a&scoped=true&"
import script from "./StatisticsBlock.vue?vue&type=script&lang=js&"
export * from "./StatisticsBlock.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsBlock.vue?vue&type=style&index=0&id=4c37d23a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c37d23a",
  null
  
)

export default component.exports